import React from 'react';
import { styled } from '@compiled/react';
import { Box, Stack } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { ff } from '@atlassian/jira-feature-flagging';
import MagicSearchV2 from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/software/components/magic-search';
import { MagicSearch as MagicSearchV1 } from '@atlassian/jira-illustrations/src/ui/magic-search';
import { FullWidthText } from '../../full-width-text';

export const NoRecentResults = ({ message }: { message: string }) => (
	<FullWidthText>
		<Box>
			{ff('jira.erai-1678.update-some-illustrations-to-dark-mode') ? (
				<Stack space="space.100">
					<ImageWrapperV2>
						<MagicSearchV2 alt="" fill />
					</ImageWrapperV2>
					{message}
				</Stack>
			) : (
				<Stack>
					<ImageWrapperV1>
						<MagicSearchV1 />
					</ImageWrapperV1>
					{message}
				</Stack>
			)}
		</Box>
	</FullWidthText>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ImageWrapperV1 = styled.div({
	// There is no other way to pass the image the right css
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	img: {
		objectFit: 'contain',
		height: token('space.600', '48px'),
		width: 'auto',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ImageWrapperV2 = styled.div({
	height: token('space.600', '48px'),
	position: 'relative',
});
